import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { AppIndexRouter } from './application/router/AppIndexRouter';
import { oidcConfig, onSigninCallback } from './application/security/auth';
import store, { persistor } from './application/store';
import 'react-toastify/dist/ReactToastify.css';

const container = document.getElementById('user-admin')!;
const root = createRoot(container);
root.render(
    <AuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
        <Provider store={store}>
            <PersistGate loading={<span>Loading</span>} persistor={persistor}>
                <AppIndexRouter />
            </PersistGate>
        </Provider>
    </AuthProvider>,
);
